import { render, staticRenderFns } from "./MStoreVersionsTab.vue?vue&type=template&id=7e043a97&"
import script from "./MStoreVersionsTab.vue?vue&type=script&lang=ts&"
export * from "./MStoreVersionsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports